import React, { useEffect } from "react";
// import Navbar from "../Navbar";
// import FindLoan from "./FindLoan";
import Serve from "./Serve/Serve.jsx";
import Types from "./Types/Types.jsx";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import HomeLoanEligibility from "./LAPEligibility/HomeLoanEligibility.jsx";
import LAPEligibility from "./LAPEligibility/LAPEligibility.jsx";
import { Helmet } from "react-helmet-async";

const LoanAgainstPropertyForm = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Helmet>
        <title>Loan Against Property Eligibility Check - Minemi</title>{" "}
      </Helmet>
      <LAPEligibility />
      <Serve />
      <Types />
      <ToastContainer />
    </>
  );
};

export default LoanAgainstPropertyForm;
